require('./src/assets/scss/init.scss');

// Import Fixedsys font (used for monospace/code content)
require('fixedsys-css/css/fixedsys.css');

// Import React95 core styles and theme
require('@react95/core/themes/win95.css');
require('@react95/core/GlobalStyle');

// Import React95 components to include their styles in the build
require('@react95/core/Button');
require('@react95/core/Alert');
require('@react95/core/Avatar');
require('@react95/core/Checkbox');
require('@react95/core/Cursor');
require('@react95/core/Dropdown');
require('@react95/core/Fieldset');
require('@react95/core/Frame');
require('@react95/core/Input');
require('@react95/core/List');
require('@react95/core/Modal');
require('@react95/core/ProgressBar');
require('@react95/core/RadioButton');
require('@react95/core/Range');
require('@react95/core/Tabs');
require('@react95/core/TaskBar');
require('@react95/core/TextArea');
require('@react95/core/TitleBar');
require('@react95/core/Tooltip');
require('@react95/core/Tree');
require('@react95/core/Video');
